import { render } from "./BasicColumnAreaChart.vue?vue&type=template&id=0796d80b&ts=true"
import script from "./BasicColumnAreaChart.vue?vue&type=script&lang=ts"
export * from "./BasicColumnAreaChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__